import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../firebase';

/** Estimate workspace storage from document HTML content (bytes). */
export function estimateDocumentSizeBytes(content: unknown): number {
  if (typeof content !== 'string') return 512;
  return Math.max(512, content.length * 2);
}

export async function estimateWorkspaceStorageBytes(workspaceId: string): Promise<number> {
  let total = 0;
  try {
    const docsSnap = await getDocs(
      query(collection(db, 'workspaces', workspaceId, 'documents'), limit(500)),
    );
    for (const d of docsSnap.docs) {
      const data = d.data();
      total += estimateDocumentSizeBytes(data.content);
      if (typeof data.tabContent === 'string') {
        total += estimateDocumentSizeBytes(data.tabContent);
      }
    }
  } catch {
    // ignore
  }
  return total;
}

export function bytesToMb(bytes: number): number {
  return bytes / (1024 * 1024);
}

export function mbToBytes(mb: number): number {
  return mb * 1024 * 1024;
}

export function formatStorageMb(bytes: number): string {
  const mb = bytesToMb(bytes);
  if (mb >= 1024) return `${(mb / 1024).toFixed(1)} GB`;
  return `${Math.round(mb)} MB`;
}
